import { useDeliveryApi } from 'infrastructure/api';
import { backupValidation, replacementValidation } from './createUpdate/backupValidation';
import { CreateUpcomingChangeCommand, UpdateUpcomingChangeCommand } from './types';

const useUpcomingChangesService = () => {
  const { sendPostRequest, sendPutRequest, sendDeleteRequest } = useDeliveryApi();

  const createUpcomingChange = async (projectId: string, command: Omit<CreateUpcomingChangeCommand, 'projectId'>) => {
    const response = await sendPostRequest(`/projects/${projectId}/upcoming-changes`, {
      ...command,
      projectId,
    });

    return response.json();
  };

  const updateUpcomingChange = async (id: string, command: Omit<UpdateUpcomingChangeCommand, 'id'>) => {
    const response = await sendPutRequest(`/upcoming-changes/${id}`, {
      ...command,
      id,
    });
    return response.json();
  };

  const deleteUpcomingChange = async (id: string) => {
    const response = await sendDeleteRequest(`/upcoming-changes/${id}`);
    return response;
  };

  const searchUpcomingChanges = async (searchRequest: any) => {
    const response = await sendPostRequest('/upcoming-changes/search', searchRequest);
    return response.json();
  };

  const getBackupValidationSchema = () => Promise.resolve(backupValidation);
  const getReplacementValidationSchema = () => Promise.resolve(replacementValidation);

  return {
    createUpcomingChange,
    updateUpcomingChange,
    deleteUpcomingChange,
    searchUpcomingChanges,
    getBackupValidationSchema,
    getReplacementValidationSchema,
  };
};

export default useUpcomingChangesService;
